if (!window.risuonoFactsSubscribed && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  window.risuonoFactsSubscribed = true;
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (!data?.variant?.options || !data.sectionId) return;
    const info = document.getElementById(`ProductInfo-${data.sectionId}`);
    const facts = info?.querySelector('.risuono-pdp-facts');
    if (!facts) return;
    const noteIndex = Number(facts.dataset.risuonoNoteIndex);
    const scaleIndex = Number(facts.dataset.risuonoScaleIndex);
    const note = facts.querySelector('[data-risuono-notes]');
    const scale = facts.querySelector('[data-risuono-scale]');
    if (note && noteIndex >= 0 && data.variant.options[noteIndex]) note.textContent = data.variant.options[noteIndex];
    if (scale && scaleIndex >= 0 && data.variant.options[scaleIndex]) scale.textContent = data.variant.options[scaleIndex];
  });
}
